"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pageSwitch = _interopRequireDefault(require("./page-switch.props/page-switch.propTypes"));

var _excluded = ["tab", "getComponents", "theme"];

var SubComponent = function SubComponent(_ref) {
  var tab = _ref.tab,
      getComponents = _ref.getComponents,
      theme = _ref.theme,
      restProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, getComponents(tab, theme, restProps));
};

SubComponent.propTypes = {
  tab: _pageSwitch["default"],
  getComponents: _propTypes["default"].func,
  theme: _propTypes["default"].objectOf(_propTypes["default"].string)
};
var _default = SubComponent;
exports["default"] = _default;